import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  StandardLayout,
  PageTitle,
  Spinner,
  Center
} from '@sequencehq/core-components'
import { Preview } from 'Invoices/components/CreateEditShared/Preview'
import { Editor } from './Editor'
import { useInvoiceEditing } from 'Invoices/hooks/useInvoiceEditing'
import {
  HeaderTitle,
  SplitLayout,
  InvoiceInspector
} from 'Invoices/components/CreateEditShared'
import { Provider, useAtomValue } from 'jotai'
import {
  humanReadableInvoiceNumberAtom,
  invoiceStatusAtom
} from '../../atoms/invoiceEditing.atom'
import { HeaderActions } from './Editor/components'
import { invoicePaths } from 'modules/Invoices'
import { useNavigate } from 'react-router-dom'
import NotFound from 'components/ErrorPages/NotFound'
import PageError from 'components/ErrorPages/PageError'
import { useIsInvoiceEditable } from 'Invoices/hooks/useIsInvoiceEditable'
import { useStandardLayoutModalPortalRoot } from 'components/Layout/StandardLayoutModalPortalRoot'

const CreateInvoicePageComponent = () => {
  const { id } = useParams()

  const invoiceEditing = useInvoiceEditing(id ?? '')

  const { invoiceIsLoading, invoiceNotFound, invoiceIsError } = invoiceEditing

  const invoiceNumber = useAtomValue(humanReadableInvoiceNumberAtom)

  const invoiceStatus = useAtomValue(invoiceStatusAtom)

  const isEditable = useIsInvoiceEditable()
  const standardLayoutModalPortalRoot = useStandardLayoutModalPortalRoot()

  const navigate = useNavigate()

  useEffect(() => {
    if (invoiceStatus && !isEditable && id) {
      navigate(invoicePaths.edit(id))
    }
  }, [isEditable, id, navigate, invoiceStatus])

  if (invoiceIsError) return <PageError />
  if (invoiceNotFound) return <NotFound />

  return (
    <>
      <PageTitle title={[invoiceNumber, 'Invoices']} />
      <StandardLayout
        asModal
        portalTarget={standardLayoutModalPortalRoot}
        header={
          <StandardLayout.Header
            padding="0 8px 0 16px" // align with inspector
            title={<HeaderTitle />}
            actions={<HeaderActions />}
          />
        }
        content={
          invoiceIsLoading ? (
            <Center width="100%" height="100%">
              <Spinner />
            </Center>
          ) : (
            <SplitLayout leadingSide={<Editor />} trailingSide={<Preview />} />
          )
        }
        inspector={<InvoiceInspector />}
      />
    </>
  )
}

export const CreateInvoicePage = () => (
  <Provider>
    <CreateInvoicePageComponent />
  </Provider>
)
